export default __webpack_public_path__ + "static/6755-ce1c60a948c63c5fb65fafde64701752.jpg";